import { render, staticRenderFns } from "./ClientV2.vue?vue&type=template&id=9bae426c&scoped=true"
import script from "./ClientV2.vue?vue&type=script&lang=js"
export * from "./ClientV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bae426c",
  null
  
)

export default component.exports